/* eslint-disable */
// As a component, props are always unpredictable so PropTypes isn't possible in here

import Filter from ".."

const FilterFieldsLeftButtonRight = ({ children, ...props }) => (
  <Filter {...props}>    
    <div style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 15,
      width: '100%',
    }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 15, flexGrow: 1 }}>
        {children}
      </div>
    </div>
  </Filter>
)

export default FilterFieldsLeftButtonRight